import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-feedback-dialog',
  templateUrl: './feedback-dialog.component.html',
  styleUrls: ['./feedback-dialog.component.scss'],
})
export class FeedbackDialogComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    this.loadHubSpotScript();
  }

  loadHubSpotScript(): void {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/v2.js';
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      this.renderHubSpotForm();
    };
    document.body.appendChild(script);
  }

  renderHubSpotForm(): void {
    (window as any).hbspt.forms.create({
      region: 'na1',
      portalId: '7315697',
      formId: 'bc010519-0e46-4b3e-b292-2ef15b5e060c',
      target: '#hubspotFormContainer',
    });
  }
}
